import setup from "./setup";
setup();

import pym from "pym.js";
import makeItem from "./chart-template";
import dataUrl from "../data/data.csv";

// import { setupVisualsGoogleAnalytics, trackEvent } from "./analytics";

const d3 = Object.assign({},
    require("d3-selection"),
    require("d3-time-format"),
    require("d3-fetch")
);

var parseTime = d3.timeParse("%Y-%m-%d");

let items = [];

function init() {

    Promise.all([
        d3.csv(dataUrl)
    ]).then(([data]) => {
        main(data);
    });

}


function main(data) {

    // console.log(data);

    data.forEach(d => {
        d.dateVal = parseTime(d.pubdate);
    })

    let series = data.sort((a, b) => {
        return b.dateVal - a.dateVal;
    })

    series = series.filter(d=> {
    	return !d.depricated;
    })


    series.forEach(obj => {

        let itemDiv = d3.select(".items")
            .append("div")
            .attr("class", d => `item item-${obj.slug}`);

        let item = new makeItem({
            element: document.querySelector(`.item.item-${obj.slug}`),
            data: obj
        });

        items.push(item);

    })

    new pym.Child({
        polling: 500
    });
}

window.onload = init;
